import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import PostListState from 'flarum/forum/states/PostListState';
import PostsUserPage from 'flarum/forum/components/PostsUserPage';
import CommentPost from 'flarum/forum/components/CommentPost';
let currentLikesPage = null;
function isLikesPage() {
  return !!(app.current && app.current.data && app.current.data.routeName === 'user.likes');
}
function isOwnLikesPage() {
  if (!isLikesPage() || !app.session.user) return false;
  const user = app.current.data.user;
  return !!(user && typeof user.id === 'function' && String(user.id()) === String(app.session.user.id()));
}
app.initializers.add('val-ui-likes-page-state', () => {
  /*
   * La page J’aime doit charger la relation likes :
   * sinon le bouton natif ne sait pas que le post est déjà aimé.
   */
  extend(PostListState.prototype, 'requestParams', function (params) {
    if (!isLikesPage()) return;
    if (!Array.isArray(params.include)) {
      params.include = [];
    }
    if (!params.include.includes('likes')) {
      params.include.push('likes');
    }
  });

  /*
   * Conserver la référence au PostsUserPage actuellement utilisé par
   * la route user.likes, afin de pouvoir retirer un post de sa liste.
   */
  extend(PostsUserPage.prototype, 'show', function () {
    if (isLikesPage()) {
      currentLikesPage = this;
    }
  });

  /*
   * Le Like natif modifie bien la relation en mémoire mais ne force pas
   * explicitement le redraw.
   *
   * Sur notre propre page J’aime, un unlike doit en plus faire disparaître
   * immédiatement le post de la liste.
   */
  extend(CommentPost.prototype, 'actionItems', function (items) {
    if (!items.has('like')) return;
    const button = items.get('like');
    if (!button || !button.attrs || typeof button.attrs.onclick !== 'function' || button.attrs.__valLikesWrapped) {
      return;
    }
    const post = this.attrs.post;
    const likes = post.likes();
    const wasLiked = !!(app.session.user && likes && likes.some(user => user === app.session.user));
    const originalOnclick = button.attrs.onclick;
    button.attrs.onclick = function () {
      const result = originalOnclick(...arguments);

      /*
       * Met immédiatement à jour "J’aime" / "Annuler mon J’aime"
       * et la ligne "Aimé par…".
       */
      m.redraw();

      /*
       * Sur sa propre page J’aime, un unlike signifie que le post
       * ne doit plus faire partie de cette liste.
       */
      if (wasLiked && isOwnLikesPage() && currentLikesPage && currentLikesPage.posts && typeof currentLikesPage.posts.remove === 'function') {
        currentLikesPage.posts.remove(post);
        m.redraw();
      }
      return result;
    };
    button.attrs.__valLikesWrapped = true;
  });
}, -100);